import React from "react";
import { Box, Card, CardHeader, CardContent, Avatar, Grid } from "@mui/material";
import { indigo } from "@mui/material/colors";
import { PatientData } from "../Contexts";
import { BiBookHeart } from "react-icons/bi";
import InfoModule from "../layout/InfoModule";
import BottomNavigation from "../layout/BottomNavigation";

export default function InfoCenterPage() {
  const patient = React.useContext(PatientData);
  const [activeStep, setActiveStep] = React.useState(0);
  const [content, setContent] = React.useState(null);

  React.useEffect(() => {
    setContent({
      title: patient.patient_info_modules[activeStep].title,
      body: patient.patient_info_modules[activeStep].body,
      idx: activeStep,
    });
  }, [activeStep]);

  return (
    <Card className="patient-info">
      <Box className="bb" mb={4}>
        <CardHeader
          avatar={
            <Avatar sx={{ color: indigo[900], bgcolor: "#f6f6f6" }}>
              <BiBookHeart style={{ fontSize: "21px", color: indigo[900] }} />
            </Avatar>
          }
          title={"Patient Info Center"}
        />
      </Box>
      <CardContent>
        <InfoModule {...content} />
      </CardContent>
      <BottomNavigation
        activeStep={activeStep}
        disableNext={patient.patient_info_modules.length - 1}
        steps={patient.patient_info_modules.length}
        variant="dots"
        handleStep={(step) => setActiveStep(step)}
      />
    </Card>
  );
}
